export default "__VITE_ASSET__ia1pz_yL__"